import editable from './editable';
import nfl from './nfl'

export default {
  currentTab: '',
  widgetToUpdate: '',
  activeToolbarItem: '',
  toolbarItems: [
    'computedProps',
    'dataTree',
    'customCode'
  ],
  authStateChecked: false,
  userId: null,
  currentDash: '',
  dashOwner: '',
  dashboardSheets: [],
  $sheets: {},
  isUserAnonymous: false,
  caslRules: [],
  processes: {},
  errors: [],
  globalCustomJs: '',
  scopedCustomJs: '',
  dashboardNotRendered: false,
  // additional
  ...editable,
  ...nfl,
  dashboardModels: {}
}



// WEBPACK FOOTER //
// ./src/store/states/index.js